namespace orderEnum {
  export enum Status {
    Cart = "سبد-خرید",
    SetPrice = "در-انتظار-قیمت-دهی",
    CallPrice = "اعلام-قیمت" ,
    ClientApproved = "تایید-برای-خرید",
    WaitToPay = "در-انتظار-پرداخت",
    WaitToBuy = "در-انتظار-خرید",
    PickBuyer = "انتخاب-مسئول-خرید",
    Canceled = "لغو-شده",
    Accounting = "accounting",
    Packing = "بسته-بندی",
    IsBought = "خریداری-شده",
    Sent = "ارسال-شده",
    ReadyToSend = "آماده-ارسال",
    NotAnswered = "بدون-پاسخ",
    CallYouLater = "خبر-میدهم",

  }
}
export default orderEnum;
